import { Provider } from "mobx-react";
import { Alert } from "antd";

import { CrudHeader } from "../_common/CrudHeader";
import { CrudFormModal } from "../_common/CrudFormModal";
import { CrudDeleteModal } from "../_common/CrudDeleteModal";

import { UserController } from "./UserController";
import { UserForm } from "./components/form/UserForm";
import { UserTable } from "./components/table/UserTable";
// import { UserAnalytics } from "./components/analytics//UserAnalytics";

import { translateKey as t } from "../../../locales/translation";
import { AppStore } from "~/stores/AppStore";

import "./Users.scss";
import { useEffect, useMemo } from "react";

const Users = ({ store }: { store: AppStore }) => {
  // const userController = new UserController(store);
  const userController = useMemo(() => new UserController(store), [store]);

  console.log("RENDER CLIENTS");

  useEffect(() => {
    userController.loadDependencies();

    userController.crudCommon.enableKeyboardShortcuts();
    document.title = t("lblUsers", "Users") + " - openFleet Pro";

    window.addEventListener("beforeunload", (event) => {
      if (userController.modifiedRows.length > 0) {
        event.returnValue = null;
      }
    });
  }, [userController]);

  const checkPasswordChange = () => {
    const { user } = userController;

    let checkPasswordChange: boolean = false;

    if (user.provider === "local") {
      if (userController.formMode === "edit") {
        if (user.password || user.confirmPassword) {
          checkPasswordChange = true;
        }
      } else {
        checkPasswordChange = true;
      }
    }

    if (checkPasswordChange) {
      if (user.password && user.password.trim()) {
        if (user.password.trim() !== (user.confirmPassword && user.confirmPassword.trim())) {
          userController.store.displayNotification(
            t("lblConfirmedPasswordDoesNotMatch", "Confirmed password does not match"),
            "error",
            true
          );
          return true;
        }
      }
    }
  };

  const handleFormSave = async () => {
    try {
      const values = await userController.formRef.validateFields(); // Validate form fields

      if (checkPasswordChange()) {
        return;
      }

      console.log("saveFormUser");
      userController.saveFormUser();
    } catch (error) {
      console.error("Validation Failed:", error);
    }
  };

  const { isReadOnly, isSelectedUserReadOnly } = userController;

  return (
    <div className="Users_Main_Container">
      <CrudHeader title={t("lblUsers", "Users")} controller={userController} />
      <UserTable controller={userController} store={store} />
      <CrudFormModal
        controller={userController}
        form={<UserForm userController={userController} />}
        onSave={() => handleFormSave()}
        onClose={() => {
          if (isSelectedUserReadOnly) {
            userController.isSelectedUserReadOnly = false;
          }
        }}
        entity="user"
        itemName={t("lblUser", "User")}
        activeSwitch={{
          propertyAccessor: "active",
          title: t("lblActive", "Active"),
          disabled: isReadOnly || isSelectedUserReadOnly,
        }}
        extraElementsInHeader={
          isSelectedUserReadOnly && (
            <Alert
              message={t(
                "ThisUserHasAHigherRoleThanYoursThereforeYouCannotEditIt.",
                "This user has a higher role than yours, therefore you cannot edit it."
              )}
              type="warning"
              style={{
                margin: "auto",
                marginLeft: 10,
                padding: 1,
                display: "inline-block",
                width: 400,
                textAlign: "center",
              }}
            />
          )
        }
        centered
        canMaximize
        bodyStyle={{ padding: "0px 16px 16px 16px", maxHeight: "75vh", overflowY: "auto" }}
        size={userController.formModalSize}
      />
      <CrudDeleteModal modalProps={userController.deleteModal} controller={userController} />
      {/* <UserAnalytics /> */}
    </div>
  );
};

export { Users };
